export default (input) =>
  input
    ?.split(' ')
    ?.map((word) => word.charAt(0))
    ?.join('')
    ?.toUpperCase();
